// @flow

import _ from 'lodash'
import React from 'react'

import { useShop } from '../../../../../../hooks'

import { PanelInput } from '../common/PanelInput'
import { PanelHeader } from '../common/PanelHeader'
import { CustomerServicePanelDescription } from './CustomerServicePanelDescription'
import { ShopSystemIntegration } from './ShopSystemIntegration/ShopSystemIntegration'
import { CustomerServiceCustomInstructionsDescription } from './CustomerServiceCustomInstructionsDescription'

import './CustomerServicePanel.scss'

export function CustomerServicePanel () {
  const [shop, handlePropertyChange] = useShop()

  return (
    <div className="settings-item-wrapper">
      <PanelHeader
        title="Customer Service Customizations"
      />
      <PanelInput
        value={shop.custom_config.customerService?.intentPrompt}
        title="Shop Insight"
        description={<CustomerServicePanelDescription />}
        placeholder="Give our AI some short insight about your shop"
        onBlur={_.debounce((val) => handlePropertyChange('custom_config.customerService.intentPrompt', val), 50)}
      />
      <PanelInput
        value={shop.custom_config.customerService?.customInstructions}
        title="Custom Instructions"
        placeholder="Custom Instructions for the AI"
        description={<CustomerServiceCustomInstructionsDescription />}
        onBlur={_.debounce((val) => handlePropertyChange('custom_config.customerService.customInstructions', val), 50)}
      />
      <ShopSystemIntegration />
    </div>
  )
}
